import React, { FunctionComponent } from "react";
import { DniField, NameField } from "$components/Fields";
import { FormSection } from "$components/FormSection";
import { IComponent } from "./interfaces";
import { PositiveIntegerField } from "$components/Fields";
import styles from "./styles.module.scss";
import classNames from "classnames";

export const PersonalInformationFormSection: FunctionComponent<IComponent> = ({
  className,
  withoutPadron,
  translations
}) => (
  <FormSection className={className} title={translations.title}>
    <div className={styles.firstRow}>
      <NameField
        className={styles.name}
        mandatory
        name="user.name"
        label={translations.name}
        withoutMargin
      />
      <NameField
        className={styles.surname}
        mandatory
        name="user.surname"
        label={translations.surname}
        withoutMargin
      />
    </div>
    <div className={styles.firstRow}>
      <DniField
        mandatory
        autoFocus
        className={classNames(styles.email, { [styles.withoutMargin]: withoutPadron })}
        // Aclaracion: Aca antes iba el campo del mail que ahora ya no se puede
        // permitir cambiar. Por eso quedo el styles.email. Si uso el styles.dni
        // no se tiene el margin que se necesita.
        name="user.dni"
        label={translations.dni}
        withoutMargin
      />
      {!withoutPadron && (
        <PositiveIntegerField
          className={styles.padron}
          name="padron"
          label={translations.padron}
          withoutMargin
          helperText="Este campo es obligatorio para estudiantes"
        />
      )}
    </div>
  </FormSection>
);
